import React, { useRef } from 'react'
import '../../Styles/Multiomics.scss'
import laborotoryimage from '../../Assests/LaboratoryImages/laborotaryPNG.png'
import bioInformatics from '../../Assests/LaboratoryImages/bioInfoPNG.png'
import gutMicrobe from '../../Assests/LaboratoryImages/gutMicrobePNG.png'
import perosnalized from '../../Assests/LaboratoryImages/persoanlizedPNG.png'
import proteomics from '../../Assests/LaboratoryImages/proteomicsPNG.png'
import genomicsG from '../../Assests/LaboratoryImages/gnomicsPNG.png'
import expertVal from '../../Assests/LaboratoryImages/expertValPNG.png'
import metabolics from '../../Assests/LaboratoryImages/metabolomicsPNG.png'
import sample from '../../Assests/LaboratoryImages/samplePNG.png';


function LaboratoryServices() {

    const teamSectionRef = useRef(null);

    const scrollToSection = () => {
        if (teamSectionRef.current) {
            teamSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <>
            <div className='advanced-multiHeight'>
                <div className='row w-100 '>

                    <div className='col-md-6   p-5'>
                        <div className='  advanced-multi-omics overall-text-color pt-5' >

                            <div>
                                Advanced Multi-Omics
                            </div>
                            <div>
                                analysis and
                            </div>
                            <div>
                                Personalized Health
                            </div>
                            <div>
                                Solutions
                            </div>
                        </div>
                        <div className='advanced-multi-omics-sub mt-3'>
                            <div >
                                At our cutting-edge facility, we provide comprehensive health insights using advanced Multi-Omics analysis tools and expertise.
                            </div>
                        </div>
                        <div className='d-flex justify-content-center primary-btn  py-2  px-2  mt-5 fw-bold explore-btn' onClick={scrollToSection} >
                            <div>Explore Our services</div>
                            <span class="material-symbols-outlined ms-1">
                                arrow_downward
                            </span>
                        </div>
                    </div>
                    <div className='col-md-6 '>
                        <div >
                            <img className='laborotoryimage-image' alt="Laboratory equipment" src={laborotoryimage} />
                        </div>
                    </div>
                </div>
                <div className='advanced-multiomicsBackground  mt-3 w-100 '>
                    <div className='fs-1 fw-bold overall-text-color text-center center-ourservices Comprehensive-text py-5' style={{ color: '#493158' }} ref={teamSectionRef}>
                        Our Services Include
                    </div>

                    <div className='d-flex mt-5 justify-content-center '>
                        <div className='right-image'>
                            <img src={genomicsG} alt="genomics" style={{ width: '100%' }} />

                            <div
                                className='right-text'
                            >
                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}>Genomics and Transcriptomics</div>
                                <p className='fontSize-of-genomics'>
                                    We utilize <strong>high-throughput Next-Generation Sequencing (NGS)</strong> to analyze
                                    genetic and transcriptomic data revealing valuable insights into DNA
                                    and gene expression patterns.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex mt-5 justify-content-center' >
                        <div style={{ position: 'relative' }}>
                            <img src={proteomics} alt="genomics" style={{ width: '100%' }} />

                            <div
                                className='left-text'

                            >
                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}>Proteomics</div>
                                <p className='fontSize-of-genomics'>
                                    Using <strong>advanced mass spectrometry,</strong> we
                                    conduct high-resolution proteomic analysis
                                    identifying proteins that play key roles in
                                    disease mechanisms and biomarker discovery
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className='d-flex mt-5 justify-content-center' >
                        <div className='right-image'>
                            <img src={metabolics} alt="genomics" style={{ width: '100%' }} />

                            <div
                                className='right-text'
                            >

                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}>Metabolomics and Lipidomics</div>
                                <p className='fontSize-of-genomics'>
                                    We employ <strong>LC-MS/MS</strong> for metabolomics
                                    to investigate biochemical pathways and
                                    metabolic health. Additionally, <strong>LC-MS </strong>
                                    enables precise lipid profiling to understand
                                    lipid metabolism and its implications for
                                    health and disease.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex mt-5 justify-content-center' >
                        <div style={{ position: 'relative' }}>
                            <img src={gutMicrobe} alt="genomics" style={{ width: '100%' }} />

                            <div
                                className='left-text'
                            >
                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}>Gut Microbiome Profiling</div>
                                <p className='fontSize-of-genomics'>
                                    Through advanced sequencing, we provide
                                    detailed analysis of the gut microbiome’s
                                    composition and functionality offering
                                    insights into its role in digestion, immunity,
                                    and overall health.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className='d-flex mt-5 justify-content-center' >
                        <div className='right-image'>
                            <img src={sample} alt="genomics" style={{ width: '100%' }} />
                            <div
                                className='right-text'
                            >
                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}>Sample Collection Kits</div>
                                <p className='fontSize-of-genomics'>
                                    We provide easy-to-use sample collection
                                    kits designed to maintain sample integrity
                                    for:
                                    <div className='fw-bold '>
                                        <ul>
                                            <li>
                                                Stool
                                            </li>
                                            <li>
                                                Urine
                                            </li>

                                            <li>
                                                Saliva
                                            </li>
                                            <li>
                                                Blood
                                            </li>
                                        </ul>
                                    </div>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex mt-5 justify-content-center'>
                        <div style={{ position: 'relative' }}>
                            <img src={bioInformatics} alt="genomics" style={{ width: '100%' }} />

                            <div
                                className='left-text'
                            >
                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}> Bioinformatics Pipeline</div>
                                <p className='fontSize-of-genomics'>

                                    Our advanced bioinformatics pipeline employs sophisticated
                                    tools and methodologies to process and analyze complex biological data
                                    ensuring precise and actionable insights.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className='d-flex mt-5 justify-content-center' >
                        <div className='right-image'>
                            <img src={expertVal} alt="genomics" style={{ width: '100%' }} />

                            <div
                                className='right-text-expert'
                            >
                                <div className='fs-4 fw-bold' style={{ color: '#493158' }}>Expert Validation by  Computational Biologists</div>
                                <p className='fontSize-of-genomics'>
                                    Every report is meticulously reviewed and
                                    validated by experienced computational
                                    biologists to ensure clinical accuracy and
                                    relevance before being shared with you.
                                </p>
                            </div>
                        </div>
                    </div>


                    <div
                        className="d-flex mt-5 justify-content-center"

                    >
                        <div style={{ position: 'relative' }}>
                            <img src={perosnalized} alt="genomics" style={{ width: '100%' }} />

                            <div
                                // style={{
                                //     position: 'absolute',
                                //     top: '10%',
                                //     right: '47%',
                                //     width: '100%',
                                // }}
                                className='left-text'
                            >
                                <div className="personalized-container">
                                    <div className="personalized-title fw-bold fs-4 text-end">Personalized Supplements</div>
                                    <p className="personalized-description fontSize-of-personalized">
                                        Based on comprehensive health data, we formulate tailored nutritional solutions including:
                                    </p>

                                    <div className="text-start personalized-list  fontSize-of-personalized" style={{ lineHeight: '1.2' }}>
                                        <ul>
                                            <li className="personalized-list-item">
                                                {/* <div className="list-title">Micronutrient and Macronutrient</div> */}
                                                <div className="list-title">
                                                    <strong>Micronutrient and Macronutrient Supplements</strong> to meet your body’s essential nutritional needs.
                                                </div>
                                            </li>
                                        </ul>

                                        <ul>
                                            <li className="personalized-list-item">
                                                <div>
                                                    <strong>Customized Supplements</strong> designed to
                                                </div>
                                                <div>support your unique biological profile for</div>
                                                <div>optimal health outcomes.</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div className='text-center center-ourservices fontSize-of-holistic holistic-text' 
    //  style={{
    //    maxWidth: '600px', 
    //    margin: '0 auto', 
    //    textAlign: 'center', 
    //    lineHeight: '1.6'
    //  }}
     >
    <div>
        With our holistic end-to-end approach from advanced scientific analysis and bioinformatics
        to personalized health recommendations, you receive 
        reliable insights and tailored solutions to achieve your wellness goals.
    </div>
</div>

                </div>


            </div>

        </>
    )
}

export default LaboratoryServices